import React, { Component } from "react";
import { connect } from "react-redux";
import { View, StyleSheet } from "react-native";
import Text from "../../components_v2/TextFont";
import PropTypes from "prop-types";
import ScenarioModel from "../../viewModels/Scenario";
import { translate } from "../../locales/translate";
import Spinner from "../../components_v2/Spinner";
import * as ScenarioActions from "../../actions/ScenarioActions";
import ToastAlert from "../../nativeBase-ui/ToastAlert";
import runResultHandler from "../runResultHandler";
import { Collapse } from "native-base";

class ScenarioSummary extends Component {
  static propTypes = {
    model: PropTypes.object,
    scenarioId: PropTypes.number,
    scenarioUId: PropTypes.string,
    hasDetail: PropTypes.bool,
    enable: PropTypes.bool,
    actionReverseDictionary: PropTypes.arrayOf(PropTypes.shape()),
    style: PropTypes.shape(),
  };
  constructor(props) {
    super(props);
    let model = new ScenarioModel();
    if (this.props.model) {
      Object.assign(model, this.props.model);
    }
    let { scenarioId, scenarioUId } = this.props;
    this.state = {
      model,
      scenarioId,
      scenarioUId,
      accessToken: undefined,
      runResult: null,
      collapseShow: false,
    };
  }

  componentDidMount() {
    let { currentServer } = this.props.appReducer;
    const accessToken = currentServer.accessToken;
    this.setState({ accessToken }, () => {
      if (!this.props.hasDetail) {
        this.props.getDetails(
          this.props.scenarioId,
          this.props.scenarioUId,
          accessToken
        );
      }
    });
  }

  findScenario = (scenarioId) => {
    for (let i = 0; i < this.props.reducer.scenarios.length; i++) {
      const scenario = this.props.reducer.scenarios[i];
      if (scenario.id == scenarioId || scenario.uId == scenarioId) {
        let _model = new ScenarioModel();
        Object.assign(_model, scenario);
        return _model;
      }
    }
    return new ScenarioModel();
  };

  render() {
    var _scenarioId = this.state.scenarioId;
    if (typeof this.state.scenarioId == "number") {
      _scenarioId = this.state.scenarioId;
    } else if (typeof this.state.scenarioUId == "string") {
      _scenarioId = this.state.scenarioUId;
    }
    let _model = !_scenarioId
      ? Object.assign(new ScenarioModel(), this.state.model) ||
        new ScenarioModel() // when create new scenario
      : this.findScenario(_scenarioId); // when edit existing scenario
    if (!this.props.hasDetail) {
      return (
        <View style={{ paddingVertical: 20, minHeight: 200 }}>
          <Spinner size={42} />
        </View>
      );
    }
    let mainCondition = _model.getMainCondition();
    let optionalConditions = _model.getOptionalConditions(false);
    let optionalConditionsAfterDelay = _model.getOptionalConditions(true);
    // let allActions = _model.getActions();
    let allActions = _model.getActions();
    let allActionsReverse = _model.getActionReverse();
    let allAreaStateActions = _model.getAreaStateActions();
    let allRunScenarioActions = _model.getRunScenarioActions();

    let notifyMethods = [];
    if (_model.notifyBySms) notifyMethods.push(translate("scenario.sms"));
    if (_model.notifyByPushNotification)
      notifyMethods.push(translate("scenario.appNotification"));
    if (!_model.rolesReceiveNotification) _model.rolesReceiveNotification = "";

    let notificationReceivers = _model.rolesReceiveNotification
      .split(",")
      .map((role) => {
        return translate(`user.role.${role.toLowerCase()}`);
      })
      .join(", ");

    let notifications = translate("scenario.summary.notifyBy", {
      method: notifyMethods.join(", "),
      receivers: notificationReceivers,
    });

    var reverseSummaries = [];
    if (_model.reverseEnabled) {
      if (allActionsReverse.length > 0) {
        let dictionary = this.props.actionReverseDictionary || [];
        for (var i in allActionsReverse) {
          var action = allActionsReverse[i];
          var hasReverse = dictionary.some((d) => {
            return d.manager == action.manager && d.action == action.action;
          });
          if (hasReverse) {
            reverseSummaries.push(action.getSummary(true, dictionary));
          }
        }
      }

      var reverseScenarioSummaries = [];

      if (allRunScenarioActions.length > 0) {
        allRunScenarioActions
          .filter((s) => s.reverseEnabled)
          .forEach((s) => {
            reverseScenarioSummaries.push(s.scenarioName);
          });
      }
    }

    let runResult = null;
    const { runResult: _runResult, scenarios } = this.props.reducer;
    const { list: devices } = this.props.deviceReducer;
    const { areas } = this.props.areaReducer;

    if (_runResult) {
      if (
        _runResult.scenarioUId == this.state.scenarioUId ||
        (_runResult.scenarioId &&
          _runResult.scenarioId == this.state.scenarioId)
      ) {
        runResult = runResultHandler(_runResult, scenarios, devices, areas);
        if (runResult) {
          setTimeout(() => {
            this.props.clearRunResult();
          }, runResult.duration);
        }
      }
    }
    return (
      <View style={this.props.style || {}}>
        <View style={{ flex: 1, marginBottom: 10 }}>
          {/* === run result alert === */}
          <Collapse isOpen={runResult ? true : false} alignItems="center">
            {runResult && (
              <ToastAlert
                // closHandler={() => {
                //   this.props.clearRunResult();
                // }}
                {...runResult}
              />
              // <>
              //   <Text>{runResult.title}</Text>
              //   <Text>{runResult.description}</Text>
              // </>
            )}
          </Collapse>
          {/* === scenario name === */}
          <Text style={styles.name}>{_model.name}</Text>
          {!this.props.enable && (
            <Text
              style={{ color: "#F00", textAlign: "center", marginBottom: 8 }}
            >
              {translate("scenario.disabledHint")}
            </Text>
          )}
          {mainCondition && (
            <View style={styles.section}>
              <Text>{mainCondition.getSummary()}</Text>
            </View>
          )}

          {optionalConditions.length > 0 && (
            <View style={styles.section}>
              {/* header */}
              {optionalConditions.length == 1 && (
                <Text>
                  {translate("scenario.summary.AND_Composition_Single")}:
                </Text>
              )}
              {optionalConditions.length > 1 &&
                _model.compositionType == "AND" && (
                  <Text>
                    {translate("scenario.summary.AND_Composition_Multi")}:
                  </Text>
                )}
              {optionalConditions.length > 1 &&
                _model.compositionType == "OR" && (
                  <Text>
                    {translate("scenario.summary.OR_Composition_Multi")}:
                  </Text>
                )}
              {/* end of header */}
              {/* conditions */}
              {optionalConditions.map((c, i) => {
                try {
                  return <Text key={i}> - {c.getSummary()}</Text>;
                } catch (e) {
                  console.log(e);
                  return <Text>summary not supported</Text>;
                }
              })}
              {/* conditions */}
            </View>
          )}
          <View style={styles.section}>
            {_model.delayMillisecond > 0 && (
              <Text>
                {translate(`scenario.summary.waitForDelay`, {
                  delay: _model.delayMillisecond,
                })}
              </Text>
            )}
            {_model.delayMillisecond > 0 &&
              optionalConditionsAfterDelay.length > 0 && (
                <View style={styles.section}>
                  {/* header */}
                  {optionalConditionsAfterDelay.length == 1 && (
                    <Text>
                      {translate("scenario.summary.AND_Composition_Single")}:
                    </Text>
                  )}
                  {optionalConditionsAfterDelay.length > 1 &&
                    _model.afterDelayCompositionType == "AND" && (
                      <Text>
                        {translate("scenario.summary.AND_Composition_Multi")}:
                      </Text>
                    )}
                  {optionalConditionsAfterDelay.length > 1 &&
                    _model.afterDelayCompositionType == "OR" && (
                      <Text>
                        {translate("scenario.summary.OR_Composition_Multi")}:
                      </Text>
                    )}
                  {/* end of header */}
                  {/* conditions */}
                  {optionalConditionsAfterDelay.map((c, i) => {
                    return <Text key={i}> - {c.getSummary()}</Text>;
                  })}
                  {/* conditions */}
                </View>
              )}
            {allActions.length > 0 && (
              <Text>{translate(`scenario.summary.executeActions`)}:</Text>
            )}
            {allActions.map((c, i) => {
              return <Text key={i}> - {c.getSummary()}</Text>;
            })}
            {allAreaStateActions.map((c, i) => {
              return <Text key={i}> - {c.getSummary()}</Text>;
            })}

            {allRunScenarioActions.length > 0 && (
              <Text style={{ marginTop: 15 }}>
                {translate(`scenario.summary.executeRunScenarioActions`)}:
              </Text>
            )}
            {allRunScenarioActions.map((c, i) => {
              return <Text key={i}> - {c.getSummary()}</Text>;
            })}
            {notifyMethods.length > 0 && (
              <Text style={{ marginTop: 15 }}>{notifications}</Text>
            )}
          </View>
          {_model.reverseEnabled == true &&
            (reverseSummaries.length > 0 ||
              reverseScenarioSummaries.length > 0) && (
              <View style={styles.section}>
                <Text>
                  {translate("scenario.reverseActionsHelp", {
                    interval: _model.reverseIntervalValue,
                    intervalType: translate(
                      `timer.${_model.reverseIntervalType}`
                    ),
                  })}
                </Text>
                {reverseSummaries.map((r, i) => (
                  <Text key={i}> - {r}</Text>
                ))}
                {reverseScenarioSummaries.length > 0 && (
                  <Text style={{ marginTop: 15 }}>
                    {translate("scenario.reverseCallScenariosHelp")}
                  </Text>
                )}
                {reverseScenarioSummaries.map((s, i) => (
                  <Text key={i}>- {s}</Text>
                ))}
              </View>
            )}
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  name: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    paddingBottom: 8,
    // borderBottomColor: "#ccc",
    // borderBottomWidth: 1,
    marginHorizontal: 6,
    marginTop: 10,
  },
  section: {
    paddingBottom: 5,
    borderBottomColor: "#ccc",
    borderBottomWidth: 1,
    marginHorizontal: 6,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.ScenarioReducer,
    deviceReducer: state.DeviceReducer,
    areaReducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDetails: (scenarioId, scenarioUId, accessToken) =>
      dispatch(
        ScenarioActions.GetDetails(scenarioId, scenarioUId, accessToken)
      ),
    clearRunResult: () => dispatch(ScenarioActions.clearRunResult()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioSummary);
